<!-- Copyright (c) 2021 VMware, Inc. All rights reserved. VMware Confidential -->
<ng-content select="summary-grid-item"></ng-content>